import { Heading } from "@planningcenter/doxy-web"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { DraftFrequency, Frequency, FrequencyType } from "../types"
import { FrequencyTypeButton } from "./FrequencyTypeButton"
import { HorizontalItemScroller } from "source/giving/components/HorizontalItemScroller"
import { FrequencySummary } from "./FrequencySummary"
import { FrequencyEditable } from "./FrequencyEditable"

type FrequencySelectorProps = {
  frequency: Frequency
  draftFrequency?: DraftFrequency
}
export function FrequencySelector({
  frequency,
  draftFrequency,
}: FrequencySelectorProps) {
  const { config, dispatch } = useDonationFormContext()

  const selectType = (type: FrequencyType) =>
    dispatch({
      type: "SET_FREQUENCY_TYPE",
      payload: type,
      defaultSchedules: config.default_schedules,
    })

  return (
    <div>
      <Heading level={3} text="Frequency" />
      <HorizontalItemScroller className="mt-1">
        <FrequencyTypeButton
          active={frequency.type === "once"}
          onClick={() => selectType("once")}
        >
          Once
        </FrequencyTypeButton>
        <FrequencyTypeButton
          active={frequency.type === "monthly"}
          onClick={() => selectType("monthly")}
        >
          Monthly
        </FrequencyTypeButton>
        <FrequencyTypeButton
          active={frequency.type === "weekly"}
          onClick={() => selectType("weekly")}
        >
          Weekly
        </FrequencyTypeButton>
        <FrequencyTypeButton
          active={frequency.type === "every_other_week"}
          onClick={() => selectType("every_other_week")}
        >
          Every other week
        </FrequencyTypeButton>
        <FrequencyTypeButton
          active={frequency.type === "twice_monthly"}
          onClick={() => selectType("twice_monthly")}
        >
          Twice monthly
        </FrequencyTypeButton>
      </HorizontalItemScroller>
      {frequency.type !== "once" && (
        <div className="py-1 px-2 br-8p gc-tint9 mt-2">
          {!!draftFrequency && <FrequencyEditable {...{ draftFrequency }} />}
          {!draftFrequency && <FrequencySummary {...{ frequency }} />}
        </div>
      )}
    </div>
  )
}
